<template>
  <div>
    <RecommendedCommandQueue />
    <ItemListCollectionWrapper
      collectionModule="CommandQueueWorkflowCollection"
      defaultSortBy="createDate"
      :refreshKey="refreshKey"
      :rowsPerPageLocalStorageKey="$options.rowsPerPageLocalStorageKey"
      @fetchCollectionError="handleFetchError"
    >
      <template v-slot="slotProps">
        <ItemListPagination
          :columns="$options.columns"
          :currentPageNum="slotProps.currentPageNum"
          :isLoading="slotProps.loading"
          :itemComponent="$options.CommandQueueRow"
          :rowsPerPage="slotProps.rowsPerPage"
          :showEmptyState="showEmptyState(slotProps)"
          :sortBy="slotProps.sortBy"
          :sortDirection="slotProps.sortDirection"
          :tableData="slotProps.tableData"
          :totalCount="slotProps.totalCount"
          @pageChange="slotProps.handlePageChange"
          @sortColumn="slotProps.handleSortColumn"
        >
          <template v-slot:toolbar>
            <CommandQueueItemTableToolbar
              :searchTerm="slotProps.getSearchTerm"
              :shouldFocusSearch="slotProps.shouldFocusSearch"
              @triggerSearch="customHandleEnterSearchTerm($event, slotProps.handleEnterSearchTerm)"
            />
          </template>
        </ItemListPagination>
        <HeadingSmall
          v-if="showEmptyState(slotProps)"
          class="noResults"
          :data-test-id="$testId('emptyState')"
        >
          {{ emptyStateMessage }}
        </HeadingSmall>
      </template>
    </ItemListCollectionWrapper>
  </div>
</template>

<script>
import {
  HeadingSmall,
  ItemListPagination,
  Types,
} from '@jumpcloud/ui-components';
import {
  LocalStorageConsts,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import CommandQueueItemTableToolbar from 'client/Commands/CommandQueueItemTableToolbar.vue';
import CommandQueueRow from 'client/Commands/CommandQueueRow.vue';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import RecommendedCommandQueue from 'client/Commands/RecommendedCommandQueue.vue';

const CommandQueueWorkflowCollection = 'CommandQueueWorkflowCollection';

const { Column } = Types;
const columns = [
  Column({
    label: 'Command Name',
    dataFieldName: 'name',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'OS',
    dataFieldName: 'operatingSystem',
    width: '1fr',
  }),
  Column({
    label: 'Pending',
    dataFieldName: 'pendingCount',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Queued At',
    dataFieldName: 'createDate',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: '',
    dataFieldName: 'action',
    width: '1fr',
  }),
];

const emptyStateMsgNoResults = 'No commands found in the queue.';
const emptyStateMsgExceededMaxResults = 'The number of queued commands is too large to display. Try narrowing the scope by searching for a specific command.';
const emptyStateMsgUnknownError = 'An unknown error occurred retrieving the command queue. Try again later.';

export default {
  name: 'CommandQueueItemTable',

  components: {
    CommandQueueItemTableToolbar,
    HeadingSmall,
    ItemListCollectionWrapper,
    ItemListPagination,
    RecommendedCommandQueue,
  },

  data() {
    return {
      emptyStateMessage: emptyStateMsgNoResults,
    };
  },

  columns,
  CommandQueueRow,
  CommandQueueWorkflowCollection,
  rowsPerPageLocalStorageKey: LocalStorageConsts.commandQueueItemsRowsPerPage,

  computed: {
    ...mapGetters(CommandQueueWorkflowCollection, [
      'refreshKey',
    ]),
  },

  methods: {
    async customHandleEnterSearchTerm(searchTerm, handleEnterSearchTerm) {
      this.emptyStateMessage = emptyStateMsgNoResults;
      await handleEnterSearchTerm(searchTerm);
    },

    handleFetchError(error) {
      this.emptyStateMessage = error.message === 'Bad Request: exceeded_max_results'
        ? emptyStateMsgExceededMaxResults
        : emptyStateMsgUnknownError;
    },

    showEmptyState(slotProps) {
      return !slotProps.loading && slotProps.tableData.length === 0;
    },
  },
};
</script>

<style scoped>
.noResults {
  margin-top: 4em !important;
  text-align: center;
  width: 100%;
}
</style>
